var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-alert", { attrs: { show: "", variant: "primary p-3" } }, [
        _c("span", { staticClass: "text-xs" }, [
          _vm._v(
            " * Para modificar los atributos de los documentos a subir, es necesario seleccionarlos previamente. "
          )
        ])
      ]),
      _c("div", { staticClass: "w-100" }, [
        _c(
          "div",
          { staticClass: "text-right mt-3" },
          [
            _c("DocManagmentUploadFile", {
              attrs: {
                permission: "*",
                text: "Seleccionar",
                "upload-to": "default",
                "container-class": "w-100",
                "type-button": "small",
                "button-class": "primary",
                "data-cy": "attach-file"
              },
              on: { input: _vm.addFile },
              model: {
                value: _vm.fileToUpload,
                callback: function($$v) {
                  _vm.fileToUpload = $$v
                },
                expression: "fileToUpload"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "w-100" }, [
        _c(
          "form",
          {
            attrs: { "data-vv-scope": "file-form", autocomplete: "off" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.save($event)
              }
            }
          },
          [
            _c(
              "b-alert",
              {
                staticClass: " mt-2 mb-3 p-3",
                attrs: { variant: "danger", dismissible: "" },
                model: {
                  value: _vm.showErrorMessage,
                  callback: function($$v) {
                    _vm.showErrorMessage = $$v
                  },
                  expression: "showErrorMessage"
                }
              },
              [
                _c("span", { staticClass: "text-xs" }, [
                  _vm._v(
                    " Existen errores que debes corregir antes de continuar! "
                  )
                ])
              ]
            ),
            Object.keys(_vm.filesStack).length
              ? _c(
                  "ul",
                  { staticClass: "nav nav-tabs" },
                  _vm._l(_vm.filesStack, function(file, key, i) {
                    return _c(
                      "li",
                      {
                        key: "tab_" + i,
                        staticClass:
                          "nav-item pr-1 cursor-pointer text-gray\n          border-top-0 border-left-0 border-right-0",
                        class: {
                          "tab-selected": i === _vm.selectedTab
                        },
                        attrs: { icon: "description" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex items-baseline" },
                          [
                            _vm.filesErrors[i] > 0
                              ? _c(
                                  "span",
                                  { staticClass: "badge badge-danger" },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.filesErrors[i]) + " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c("vs-icon", {
                              attrs: {
                                icon: "description",
                                size: "small",
                                color: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.selectFile(i)
                                }
                              }
                            }),
                            _c(
                              "span",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.selectFile(i)
                                  }
                                }
                              },
                              [_vm._v(_vm._s("Documento #" + (i + 1)))]
                            ),
                            _c("vs-button", {
                              attrs: {
                                color: "danger",
                                type: "flat",
                                icon: "clear",
                                size: "small"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.removeFile(key)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._l(_vm.filesStack, function(file, key, i) {
              return _c(
                "div",
                { key: "tab_content_" + i, staticClass: "tab-content" },
                [
                  _c("keep-alive", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: i === _vm.selectedTab,
                            expression: "i === selectedTab"
                          }
                        ]
                      },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Nombre original del documento",
                              "label-for": "file_" + i + "_original_name"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "w-100",
                              attrs: {
                                name: "file_" + i + "_original_name",
                                disabled: ""
                              },
                              model: {
                                value: file.originalFileName,
                                callback: function($$v) {
                                  _vm.$set(file, "originalFileName", $$v)
                                },
                                expression: "file.originalFileName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Nombre para documento",
                              "label-for": "file_" + i + "_name"
                            }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|max:255",
                                  expression: "'required|max:255'"
                                }
                              ],
                              staticClass: "w-100",
                              attrs: {
                                id: "file_" + i + "_name",
                                name: "file_" + i + "_name",
                                autocomplete: "off",
                                "data-vv-as": "Nombre para documento",
                                state:
                                  !_vm.errors.has(
                                    "file-form.file_" + i + "_name"
                                  ) && file.name.length > 0,
                                "data-cy": "document-name"
                              },
                              model: {
                                value: file.name,
                                callback: function($$v) {
                                  _vm.$set(file, "name", $$v)
                                },
                                expression: "file.name"
                              }
                            }),
                            _c("FormError", {
                              attrs: {
                                attributeName: "file-form.file_" + i + "_name",
                                errorsForm: _vm.errors
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "¿Es un documento de acceso público?",
                              "label-for": "file_" + i + "_is_public"
                            }
                          },
                          [
                            _c(
                              "vs-switch",
                              {
                                staticClass: "w-16",
                                attrs: {
                                  id: "file_" + i + "_is_public",
                                  name: "file_" + i + "_is_public",
                                  color: "primary",
                                  "vs-icon-on": "done",
                                  "vs-icon-off": "block",
                                  "data-cy": "public-document"
                                },
                                model: {
                                  value: file.isPublic,
                                  callback: function($$v) {
                                    _vm.$set(file, "isPublic", $$v)
                                  },
                                  expression: "file.isPublic"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "pl-1",
                                    attrs: { slot: "on" },
                                    slot: "on"
                                  },
                                  [_vm._v("SI")]
                                ),
                                _c(
                                  "span",
                                  { attrs: { slot: "off" }, slot: "off" },
                                  [_vm._v("NO")]
                                )
                              ]
                            ),
                            file.isPublic
                              ? _c(
                                  "small",
                                  { staticClass: "mb-2 text-danger" },
                                  [
                                    _vm._v(
                                      " Esto dejará el archivo disponible a personas fuera de la organización "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Estado de publicación:",
                              "label-for": "file_" + i + "_is_published"
                            }
                          },
                          [
                            _c("b-form-select", {
                              staticClass: "w-100",
                              attrs: {
                                label: "",
                                id: "file_" + i + "_is_published",
                                name: "file_" + i + "_is_published",
                                options: _vm.publicationStateOptions,
                                "data-cy": "publication-status"
                              },
                              model: {
                                value: file.publicationState,
                                callback: function($$v) {
                                  _vm.$set(file, "publicationState", $$v)
                                },
                                expression: "file.publicationState"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Versión externa:",
                              "label-for": "file_" + i + "_externalVersion"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "w-100",
                              attrs: {
                                id: "file_" + i + "_externalVersion",
                                name: "file_" + i + "_externalVersion",
                                autocomplete: "off",
                                maxlength: "10",
                                "data-vv-as": "Versión externa",
                                "data-cy": "external-version"
                              },
                              model: {
                                value: file.externalVersion,
                                callback: function($$v) {
                                  _vm.$set(
                                    file,
                                    "externalVersion",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "file.externalVersion"
                              }
                            }),
                            _c("FormError", {
                              attrs: {
                                attributeName:
                                  "file-form.file_" + i + "_externalVersion",
                                errorsForm: _vm.errors
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Tipo de expiración",
                              "label-for": "file_" + i + "_expirationType"
                            }
                          },
                          [
                            _c("b-form-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "w-100",
                              attrs: {
                                label: "",
                                id: "file_" + i + "_expirationType",
                                name: "file_" + i + "_expirationType",
                                "data-vv-as": "Tipo de expiración",
                                options: _vm.expirationTypeOptions,
                                "data-cy": "expiration-type"
                              },
                              model: {
                                value: file.selectedExpirationType,
                                callback: function($$v) {
                                  _vm.$set(file, "selectedExpirationType", $$v)
                                },
                                expression: "file.selectedExpirationType"
                              }
                            }),
                            _c("FormError", {
                              attrs: {
                                attributeName:
                                  "file-form.file_" + i + "_expirationType",
                                errorsForm: _vm.errors
                              }
                            })
                          ],
                          1
                        ),
                        file.selectedExpirationType ===
                        _vm.expirationTypes.UNIQUE_EXPIRATION_IN_X_DAYS
                          ? _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Días",
                                  "label-for": "file_" + i + "_xDays"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value:
                                        "required|numeric|min_value:1|max_value:9999",
                                      expression:
                                        "'required|numeric|min_value:1|max_value:9999'"
                                    }
                                  ],
                                  attrs: {
                                    "data-vv-as": "Días",
                                    id: "file_" + i + "_xDays",
                                    name: "file_" + i + "_xDays",
                                    state:
                                      !_vm.errors.has(
                                        "file-form.file_" + i + "_xDays"
                                      ) && file.expirationInXDays > 0,
                                    change: _vm.setExpirationDate(file),
                                    type: "number",
                                    min: "1",
                                    max: "9999",
                                    "data-cy": "day"
                                  },
                                  model: {
                                    value: file.expirationInXDays,
                                    callback: function($$v) {
                                      _vm.$set(file, "expirationInXDays", $$v)
                                    },
                                    expression: "file.expirationInXDays"
                                  }
                                }),
                                _c("FormError", {
                                  attrs: {
                                    attributeName:
                                      "file-form.file_" + i + "_xDays",
                                    errorsForm: _vm.errors
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        file.selectedExpirationType !==
                        _vm.expirationTypes.NO_EXPIRATION
                          ? _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: _vm.expirationLabel(file),
                                  "label-for": "file_" + i + "_expirationDate"
                                }
                              },
                              [
                                _c("b-form-datepicker", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  staticClass: "form-control bg-white",
                                  attrs: {
                                    "reset-button": "",
                                    "label-reset-button": "Limpiar",
                                    id: "file_" + i + "_expirationDate",
                                    name: "file_" + i + "_expirationDate",
                                    "data-vv-as": "fecha de expiración",
                                    placeholder: "Selecciona una fecha",
                                    locale: "es",
                                    min: _vm.minDate,
                                    "label-help":
                                      "Puede usar las flechas del teclado y espacio",
                                    state:
                                      !_vm.errors.has(
                                        "file-form.expirationDate"
                                      ) && file.expirationDate !== null,
                                    disabled:
                                      file.selectedExpirationType ===
                                      _vm.expirationTypes
                                        .UNIQUE_EXPIRATION_IN_X_DAYS,
                                    "data-cy": "calendar"
                                  },
                                  model: {
                                    value: file.expirationDate,
                                    callback: function($$v) {
                                      _vm.$set(file, "expirationDate", $$v)
                                    },
                                    expression: "file.expirationDate"
                                  }
                                }),
                                _c("FormError", {
                                  attrs: {
                                    attributeName:
                                      "file-form.file_" + i + "_expirationDate",
                                    errorsForm: _vm.errors
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        file.selectedExpirationType !==
                        _vm.expirationTypes.NO_EXPIRATION
                          ? _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Hora de expiración",
                                  "label-for": "file_" + i + "_expirationHour"
                                }
                              },
                              [
                                _c("b-form-select", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  staticClass: "w-100",
                                  attrs: {
                                    id: "file_" + i + "_expirationHour",
                                    name: "file_" + i + "_expirationHour",
                                    options: _vm.hours,
                                    "data-vv-as": "hora de expiración",
                                    placeholder: "Selecciona una hora",
                                    state:
                                      !_vm.errors.has(
                                        "file-form.file_" +
                                          i +
                                          "_expirationHour"
                                      ) && file.expirationHour !== null,
                                    "data-cy": "hour"
                                  },
                                  on: {
                                    change: function() {
                                      return _vm.setExpirationNotification(file)
                                    }
                                  },
                                  model: {
                                    value: file.expirationHour,
                                    callback: function($$v) {
                                      _vm.$set(file, "expirationHour", $$v)
                                    },
                                    expression: "file.expirationHour"
                                  }
                                }),
                                _c(
                                  "b-form-invalid-feedback",
                                  {
                                    staticClass: "d-none w-100",
                                    attrs: {
                                      state: !_vm.errors.has(
                                        "file-form.file_" +
                                          i +
                                          "_expirationHour"
                                      )
                                    }
                                  },
                                  [_vm._v(" La hora es requerida ")]
                                ),
                                _c("FormError", {
                                  attrs: {
                                    attributeName:
                                      "file_" + i + "_expirationHour",
                                    errorsForm: _vm.errors
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "b-form-group",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  file.selectedExpirationType !==
                                    _vm.expirationTypes.NO_EXPIRATION &&
                                  file.expirationDate &&
                                  file.expirationHour,
                                expression:
                                  "file.selectedExpirationType !== expirationTypes.NO_EXPIRATION\n                && file.expirationDate && file.expirationHour"
                              }
                            ],
                            attrs: {
                              label: "Fecha de notificación",
                              "label-for": "file_" + i + "_notificationDate"
                            }
                          },
                          [
                            _c("b-form-datepicker", {
                              staticClass: "form-control bg-white",
                              attrs: {
                                "reset-button": "",
                                "label-reset-button": "Limpiar",
                                id: "file_" + i + "_notificationDate",
                                name: "file_" + i + "_notificationDate",
                                placeholder: "Selecciona una fecha",
                                value: file.notificationDate,
                                locale: "es",
                                min: _vm.fileToUpload.date.substring(0, 10),
                                max: file.expirationDate,
                                "label-help":
                                  "Puede usar las flechas del teclado y espacio",
                                "data-cy": "calendar"
                              },
                              on: {
                                input: function(val) {
                                  return _vm.setNotificationDate(val, file.id)
                                }
                              }
                            }),
                            _c("FormError", {
                              attrs: {
                                attributeName:
                                  "file-form.file_" + i + "_notificationDate",
                                errorsForm: _vm.errors
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  file.selectedExpirationType !==
                                    _vm.expirationTypes.NO_EXPIRATION &&
                                  file.expirationDate &&
                                  file.expirationHour,
                                expression:
                                  "file.selectedExpirationType !== expirationTypes.NO_EXPIRATION\n                && file.expirationDate && file.expirationHour"
                              }
                            ],
                            attrs: {
                              label: "Hora de notificación",
                              "label-for": "file_" + i + "_notificationHour"
                            }
                          },
                          [
                            _c("b-form-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    between: true,
                                    required:
                                      file.selectedExpirationType !==
                                      _vm.expirationTypes.NO_EXPIRATION
                                  },
                                  expression:
                                    "{\n                  between: true,\n                  required: file.selectedExpirationType !== expirationTypes.NO_EXPIRATION,\n                }"
                                }
                              ],
                              staticClass: "w-100",
                              attrs: {
                                id: "file_" + i + "_notificationHour",
                                name: "file_" + i + "_notificationHour",
                                options: _vm.hours,
                                "data-vv-as": "hora de notificación",
                                state:
                                  !_vm.errors.has(
                                    "file-form.file_" + i + "_notificationHour"
                                  ) && file.notificationHour !== null,
                                "data-cy": "hour"
                              },
                              model: {
                                value: file.notificationHour,
                                callback: function($$v) {
                                  _vm.$set(file, "notificationHour", $$v)
                                },
                                expression: "file.notificationHour"
                              }
                            }),
                            _c(
                              "b-form-invalid-feedback",
                              {
                                staticClass: "d-none w-100",
                                attrs: {
                                  state: !_vm.errors.has(
                                    "file-form.file_" + i + "_notificationHour"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  " La fecha y hora debe ser antes de la expiración y posterior a la de creación "
                                )
                              ]
                            ),
                            _c("FormError", {
                              attrs: {
                                attributeName:
                                  "file_" + i + "_notificationHour",
                                errorsForm: _vm.errors
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            }),
            _c(
              "div",
              { staticClass: "m-top-20 d-flex justify-end" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "mt-5 ml-3 border-primary",
                    attrs: {
                      type: "submit",
                      variant: "outline-primary",
                      disabled: !Object.keys(_vm.filesStack).length,
                      "data-cy": "save"
                    }
                  },
                  [
                    _vm._v(" Guardar "),
                    _c("span", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      staticClass: "spinner-border spinner-border-sm text-white"
                    })
                  ]
                )
              ],
              1
            )
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }